import axios from 'axios'
import getConfig from '@/utils.js'
import { useAlertStore } from '@/stores/alert'

const accountsClient = axios.create({
  baseURL: getConfig().oauthApiUrl,
  timeout: 5000,
})

const merchantClient = axios.create({
  baseURL: getConfig().merchantApiUrl,
  timeout: 5000,
})

async function request(client, jwt, args) {
  const alertStore = useAlertStore()

  try {
    args.headers = { Authorization: 'Bearer ' + jwt }
    alertStore.axiosBusyInc()
    const response = await client.request(args)
    alertStore.axiosBusyDec()
    return response.data
  } catch (error) {
    let message = {
      type: 'error',
    }
    if (error.response) {
      message.message =
        'HTTP ' + error.response.status + ': ' + error.response.data.message
    } else if (error.request) {
      message.message = 'Could not send request' + error.request
    } else {
      message.message = 'Unknown axios error: ' + error.message
    }
    alertStore.add(message)
    alertStore.axiosBusyDec()
    throw error
  }
}

export async function apiGetMyTokens(jwt) {
  const rv = await request(accountsClient, jwt, {
    url: '/api/v2/my/tokens',
    method: 'get',
  })
  return rv
}

export async function apiPostInitUser(jwt) {
  const rv = await request(merchantClient, jwt, {
    url: '/init-user',
    method: 'post',
  })
  return rv
}

export async function apiGetMerchantLinkedWithAccount(jwt, merchantIdent) {
  const rv = await request(merchantClient, jwt, {
    url: '/merchants/' + merchantIdent + '/linked-with-account',
    method: 'get',
  })
  return rv.allowed
}
